import { parseClientEnv, type ClientEnv } from "@fluentry/domain";

// Single entry point for `import.meta.env` in product-app. Anything VITE_* should be read via `clientEnv`,
// not directly off `import.meta.env`, so the SSOT lives in `packages/domain/src/client-env.schema.ts`.
// Merge `process.env` underneath so SSR / Node test contexts (where `import.meta.env` may be sparse)
// still see explicit overrides. Re-parse on every access so `vi.stubEnv` works in tests.
function readClientEnv(): ClientEnv {
  const processEnv = typeof process !== "undefined" ? (process.env as Record<string, unknown>) : {};
  const result = parseClientEnv({ ...processEnv, ...import.meta.env });
  if (!result.success) {
    throw new Error(`[product-app] client env validation failed: ${result.errorSummary}`);
  }
  return result.env;
}

export const clientEnv: ClientEnv = new Proxy({} as ClientEnv, {
  get(_target, prop) {
    return (readClientEnv() as Record<string, unknown>)[prop as string];
  },
});
